export var VisibilityKind;
(function (VisibilityKind) {
    VisibilityKind[VisibilityKind["Regular"] = 0] = "Regular";
    VisibilityKind[VisibilityKind["Tangent"] = 1] = "Tangent";
})(VisibilityKind || (VisibilityKind = {}));
//# sourceMappingURL=VisibilityKind.js.map